import { ValidateJSModel } from 'forms/shared/types/validatejs';
import pvqLocationModelValidator from 'forms/shared/validators/models/location/pvqLocation';
import { isPVQForm } from 'helpers/form';
import { DEFAULT_EARLIEST, DEFAULT_LATEST } from 'constants/dateLimits';
import { hasYesOrNo } from 'models/validate';
import { lienEntityTypes, lienPropertyTypes, lienReasonOptions } from 'constants/enums/financialOptions';
import pvqNameModelValidator from 'forms/shared/validators/models/pvqName/name';
import { setToStartOfMonth } from 'helpers/date';
import { FinancialLienItemModel } from '../types';

export const financialLienItemValidator: ValidateJSModel<FinancialLienItemModel> = {

  EntityType: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        hasValue: {
          validator: {
            inclusion: lienEntityTypes
          },
        },
      };
    }

    return {};
  },

  EntityTypeExplain: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      if (attributes.EntityType?.value === 'Other') {
        return { hasValue: true };
      }

      return {};
    }

    return {};
  },

  EntityName: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      if (['Company', 'Government Agency'].includes(attributes.EntityType?.value || '')) {
        return { hasValue: true };
      }

      return {};
    }

    return {};
  },

  PrivateName: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      if (attributes.EntityType?.value === 'Individual') {
        return {
          model: {
            validator: pvqNameModelValidator
          },
          presence: true,
        };
      }

      return {};
    }

    return {};
  },

  PropertyType: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        hasValue: {
          validator: {
            inclusion: lienPropertyTypes
          },
        },
      };
    }

    return {};
  },

  PropertyTypeExplain: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      if (attributes.PropertyType?.value === 'Other personal property') {
        return { hasValue: true };
      }

      return {};
    }

    return {};
  },

  LienReason: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        hasValue: {
          validator: {
            inclusion: lienReasonOptions
          },
        },
      };
    }

    return {};
  },

  WhyExplain: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      if (attributes.LienReason?.value === 'Other') {
        return { hasValue: true };
      }

      return {};
    }

    return {};
  },

  AmountRequiredToPay: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { hasValue: true };
    }

    return {};
  },

  When: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        date: {
          earliest: setToStartOfMonth(options?.applicantBirthdate || DEFAULT_EARLIEST),
          latest: DEFAULT_LATEST,
          requireDay: false,
          requireMonth: true,
          requireYear: true,
        },
        presence: true,
      };
    }

    return {};
  },

  WhenEstimated: {},

  Current: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        presence: true,
        hasValue: { validator: hasYesOrNo },
      };
    }
    return {};
  },

  WhenResolved: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      if (attributes.Current?.value === 'No') {
        return {
          date: {
            earliest: setToStartOfMonth(options?.applicantBirthdate || DEFAULT_EARLIEST),
            latest: DEFAULT_LATEST,
            requireDay: false,
            requireMonth: true,
            requireYear: true,
          },
          presence: true,
        };
      }

      return {};
    }

    return {};
  },
  WhenResolvedEstimated: {},
  ActionsTaken: (values, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      if (attributes.ActionsTakenNone?.applicable !== false && attributes.Current?.value === 'Yes') {
        return { hasValue: true };
      }
    }

    return {};
  },
  ActionsTakenNone: {},
  ActionsTakenReason: (values, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      if (attributes.ActionsTakenNone?.applicable === false && attributes.Current?.value === 'Yes') {
        return { hasValue: true };
      }
    }

    return {};
  },
  OfficeName: {
    presence: true,
    hasValue: true,
  },
  OfficeLocation: {
    presence: true,
    location: {
      requireCity: true,
      requireStreet: true,
      requireState: true,
      requireZipCode: true,
      validator: pvqLocationModelValidator,
    },
  },
  CaseNum: (values, attributes) => (attributes?.CaseNumIdk?.applicable !== false ? {
    presence: true,
    hasValue: true,
  } : {}),

  CaseNumIdk: {},
};
